import { SolShortcut } from '../../../services/shortcut.service';
import { AbstractComponent } from '../../abstract.component';
import { Component, Input } from '@angular/core';
import { SolIconComponent } from '../sol-icon/sol-icon.component';
import { SolShortcutView } from '../../../models/core/sol-shortcut-view';

@Component({
  selector: 'sol-shortcut',
  imports: [SolIconComponent],
  templateUrl: './sol-shortcut.component.html',
})
export class SolShortcutComponent extends AbstractComponent<SolShortcutView> {
  // Computed
  protected readonly items$ = this.compute(state => state.items);

  constructor() {
    super(SolShortcutView.of());
  }

  @Input()
  public set shortcut(shortcut: SolShortcut | undefined) {
    this.update(state => state.withShortcut(shortcut));
  }
}
